import { Button } from '@repo/ui/button'
import { useT } from '@repo/ui/hooks'
import { Input } from '@repo/ui/input'
import { TooltipWrapper } from '@repo/ui/tooltip'
import { onInput } from '@repo/ui/utils'
import { PlusIcon } from 'lucide-react'
import { useState } from 'react'

export function SectionCreator({ onCreate }: { onCreate: (label: string) => void }) {
  const { tc, t } = useT({ keyPrefix: 'admin.structuredData' })
  const [sectionLabel, setSectionLabel] = useState<string>('')

  const isEmpty = sectionLabel.trim().length === 0
  const handleCreate = () => {
    if (isEmpty) return
    onCreate(sectionLabel.trim())
    setSectionLabel('')
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) {
      e.preventDefault()
      handleCreate()
    }
  }

  return (
    <div>
      <div className="flex items-center gap-2">
        <Input
          placeholder={t('addASection')}
          className="w-fit"
          value={sectionLabel}
          onChange={onInput(setSectionLabel)}
          onKeyDown={handleKeyDown}
          type="search"
        />

        <TooltipWrapper content={tc('create', { cfl: true })}>
          <Button onClick={handleCreate} size="icon" disabled={isEmpty}>
            <PlusIcon className="size-4" />
          </Button>
        </TooltipWrapper>
      </div>
    </div>
  )
}
